import React, { useEffect } from 'react'
import Navbar from '../Navbar';
import {Box, Button, TextField,Grid,Divider, Typography} from '@mui/material';
import { useState } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, useNavigate,useParams } from 'react-router-dom';
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from '@mui/material/styles';
import { Stack } from '@mui/material';

function ViewSerial() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [masterInput, setMaster] = useState([]);
    
    const {id} = useParams();
    useEffect(()=>{
        const serialmaster_id=id;
        axios.get(`/api/view_serial/${serialmaster_id}`).then(res=>{
            if(res.data.status===200){
                setMaster(res.data.serialmaster);
            }
            else if(res.data.status === 404){
                swal("Error",res.data.message,"error");
                navigate('/certificates/serialmaster');
            }
            setLoading(false);
        });
    }, [id,navigate]);

    const handleInput = (e) => {
        e.persist();
        setMaster({...masterInput,[e.target.name]: e.target.value});
   
    }
    if(loading){
        swal({
          title: 'Loading',
          text: 'Please Wait!!!',
          timer: 1000,
          buttons: false,
        }).then(
          function () {},
          // handling the promise rejection
          function (dismiss) {
            if (dismiss === 'timer') {
              //console.log('I was closed by the timer')
            }
          }
        )
      }
      const { palette } = createTheme();
      const { augmentColor } = palette;
      const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });
      const theme = createTheme({
        palette: {
          anger: createColor('#F40B27'),
          apple: createColor('#A38A00'),
          steelBlue: createColor('#5C76B7'),
          violet: createColor('#BC00A3'),
        },
        button: { // Here is where you can customise the button
          fontSize: 16,
          fontWeight: 1700,
        }, 
      });

   

  return (
    <div>
    <Navbar />
    
    <form id="CATEGORY_FORM">
    <div className = "card px-8 m-5">
     <div className = "card-header">
     <div class="d-flex justify-content-between">
          <h4>Serial Details
          </h4>
          <ThemeProvider theme={theme}>
           <Button component={Link} to="/certificates/show_serial" variant='contained' color='apple'>back</Button>
           </ThemeProvider>
     </div>
     </div>
    <table class="table table-bordered">
  <tbody>
    <tr>
     <th>series_name</th>
      <td onChange={handleInput}>{masterInput.series_name}</td>
      <th>starting_month</th>
      <td onChange={handleInput}>{masterInput.starting_month}</td>
    </tr>
    <tr>
    <th>end_month</th>
      <td onChange={handleInput}>{masterInput.end_month}</td>
    </tr>
  </tbody>
</table>
</div>
    </form>
    </div>
  )
}

export default ViewSerial